import { ChartRangeOption } from '../../types'

// Last 7 days chart date range
const lastSevenDaysToDate = new Date()
const lastSevenDaysFromDate = new Date(lastSevenDaysToDate)
lastSevenDaysFromDate.setDate(lastSevenDaysFromDate.getDate() - 7)
const lastSevenDaysPeriodDays = 1
// Last 30 days chart date range
const lastThirtyDaysToDate = new Date()
const lastThirtyDaysFromDate = new Date(lastThirtyDaysToDate)
lastThirtyDaysFromDate.setDate(lastThirtyDaysFromDate.getDate() - 28)
const lastThirtyDaysPeriodDays = 7
// Last 90 days chart date range
const lastNinetyDaysToDate = new Date()
const lastNinetyDaysFromDate = new Date(lastNinetyDaysToDate)
lastNinetyDaysFromDate.setDate(lastNinetyDaysFromDate.getDate() - 90)
const lastNinetyDaysPeriodDays = 30
// Chart date range options
const chartRangeOptions: ChartRangeOption[] = [
  {
    id: 'last_7_days',
    display: 'Last 7 Days',
    fromDate: lastSevenDaysFromDate,
    toDate: lastSevenDaysToDate,
    periodDays: lastSevenDaysPeriodDays,
    intervalDays: 7,
  },
  {
    id: 'last_30_days',
    display: 'Last 30 Days',
    fromDate: lastThirtyDaysFromDate,
    toDate: lastThirtyDaysToDate,
    periodDays: lastThirtyDaysPeriodDays,
    intervalDays: 30,
  },
  {
    id: 'last_90_days',
    display: 'Last 90 Days',
    fromDate: lastNinetyDaysFromDate,
    toDate: lastNinetyDaysToDate,
    periodDays: lastNinetyDaysPeriodDays,
    intervalDays: 90,
  },
]
const initChartRangeOption = chartRangeOptions[1]

const selectedChartRangeOption = (selectedId: string, defaultOption = initChartRangeOption) =>
  chartRangeOptions.find((option) => option.id === selectedId) ?? defaultOption

export default {
  chartRangeOptions,
  initChartRangeOption,
  selectedChartRangeOption,
}
